module.exports = __webpack_public_path__ + "img/services-man.a35b7f17.svg";